angular.module('impactx.dashboard').controller('DashboardClientCtrl', ['$scope', 'dataGen', DashboardClientCtrl]);

function DashboardClientCtrl($scope, dataGen) {
    dataGen.getData($scope, {}, "/dashboard/client").then(function () {
        $scope.isHidden.value = !$scope.data.hasMessage;
    });
}